import { createReducer } from '@reduxjs/toolkit';
import { setLhsExpanded } from 'redux/actions/layout';
import { initialRootState } from '.';

export default createReducer(initialRootState, builder => {
  builder.addCase(setLhsExpanded, (state, action) => {
    state.app.lhsExpanded = action.payload;
  });
});
